export { default } from './SearchTermTag';
